<template>
  <div>
    <ContactSection />
  </div>
</template>

<script setup lang="ts">
import ContactSection from '@/components/ContactSection.vue';

useHead({
  title: 'Contact The Players League DFW | Get In Touch',
  meta: [
    { name: 'description', content: 'Contact The Players League DFW for inquiries about joining, league information, or any other questions. Reach us via email, phone, or Facebook.' },
    { property: 'og:title', content: 'Contact The Players League DFW | Get In Touch' },
    { property: 'og:description', content: 'Contact The Players League DFW for inquiries about joining, league information, or any other questions. Reach us via email, phone, or Facebook.' },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: 'https://theplayersleaguedfw.com/contact' },
    { property: 'og:image', content: 'https://theplayersleaguedfw.com/TPLDFW-logo.JPEG' },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: 'Contact The Players League DFW | Get In Touch' },
    { name: 'twitter:description', content: 'Contact The Players League DFW for inquiries about joining, league information, or any other questions. Reach us via email, phone, or Facebook.' },
    { name: 'twitter:image', content: 'https://theplayersleaguedfw.com/TPLDFW-logo.JPEG' }
  ]
});

/*
useSchemaOrg([
  defineContactPage(),
  defineSportsOrganization({
    name: 'The Players League DFW',
    url: 'https://www.theplayersleague.net',
    logo: 'https://www.theplayersleague.net/TPLDFW-logo.JPEG',
    sameAs: [
      'https://www.facebook.com/groups/2431630200504644',
      'https://www.facebook.com/jimdixon76033'
    ],
    sport: 'Billiards',
    location: {
      '@type': 'Place',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Fort Worth',
        addressRegion: 'TX',
        addressCountry: 'US'
      }
    },
    contactPoint: [
      {
        '@type': 'ContactPoint',
        telephone: '+1-817-655-5758',
        contactType: 'league inquiries',
        email: 'theplayersleaguedfw@gmail.com',
        areaServed: 'US'
      }
    ]
  })
])
*/
</script>

<style scoped>
div {
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>
